<template>
  <div class="custom-reports-header">
    <UiColumnsSelect
      ref="columnsPopup"
      :model-value="reports[currentReport].selectedColumns"
      :groups="columnsGroups"
      :default="defaultCols"
      :metrics="getMetrics"
      :supported="supportedMetrics"
      :is-dragged="isDragged"
      @changed="beforeGetReport"
    />

    <BookmarksModal
      ref="bookmarksModal"
      v-model:bookmarks="bookmarks"
      :reports="reports"
      :all-dimension="allDimension"
    />

    <div
      ref="tools"
      class="tools-wrap"
      :class="{wavebg: loading}"
    >
      <CustomReportsTabs
        ref="tabs"
        v-model:current-report="currentReport"
        v-model:bookmarks="bookmarks"
        :reports="reports"
        :all-dimension="allDimension"
        :cache-data="cacheData"
        :group-by-field="groupByField"
        :single-grouping-select="singleGroupingSelect"
        :grouping-selects="groupingSelects"
        @update:single-grouping-select="$emit('update:singleGroupingSelect', $event)"
        @update:grouping-selects="$emit('update:groupingSelects', $event)"
        @get-report="getReport"
        @open-bookmark-modal="openBookmarksModal"
        @reset-filters="resetFilters"
        @select-report="selectReport"
        @cache-query="$emit('cache-query')"
      >
        <template v-slot:append>
          <BookmarksList
            ref="bookmarkMain"
            v-model:bookmarks="bookmarks"
            v-model:is-popover-edit-index="isPopoverEditIndex"
            :reports="reports"
            :current-report="currentReport"
            @create-report="createReport"
          />
        </template>
      </CustomReportsTabs>

      <div
        v-if="!$_.isEmpty(currentReportFilter)"
        class="toolbar filters"
      >
        <div class="wrapper">
          <div class="item all">
            <span
              class="field"
              @click="clearCurrentFilter"
            >{{ $t('filters.all') }}</span>
          </div>
          <div
            v-for="(value, key) in currentReportFilter"
            :key="key"
            class="item"
          >
            <span class="field">
              <i
                v-if="currentReportFilter[key].op == '!='"
                class="fas fa-page-break"
                style="font-size: 11px;"
              />
              <i
                v-else
                class="far fa-random"
                style="font-size: 11px;"
              />
              {{ key === 'media_buying_channel_id' || key === 'media_buying_campaign_id' ? $t('customReports.mb') : '' }}
              {{ (allDimension.find(e => e.column_name === key) || {}).title }}:
            </span>
            <span class="value">
              {{ value.visible || reports[currentReport].currentFilterNames[key] }}
              <ElDropdown
                trigger="click"
                placement="bottom-end"
              >
                <span>{{ value.selectIdsLength }}</span>
                <template v-slot:dropdown>
                  <ElDropdownMenu>
                    <ElDropdownItem
                      v-for="(row, i) in value.selectedRowList"
                      :key="i"
                      class="!tw-flex !tw-justify-between dropdown-item-drill"
                    >
                      <div>
                        {{ row.rowTooltip }}
                      </div>
                      <span
                        class="cross-close"
                        @click="removeCurrentDrilldown(value, row)"
                      >×</span>
                    </ElDropdownItem>
                  </ElDropdownMenu>
                </template>
              </ElDropdown>
            </span>
            <span
              class="cross-close"
              @click="removeCurrentFilter(key)"
            >×</span>
          </div>
        </div>
      </div>

      <div
        class="ml-16 mr-16"
        style="position: relative"
      >
        <BookmarksListMobile
          ref="bookmarksModalMobile"
          v-model:bookmarks="bookmarks"
          v-model:is-popover-edit-index="isPopoverEditIndex"
          :reports="reports"
          :all-dimension="allDimension"
          @remove-promocode-report="removePromocodeReport"
          @create-report="createReport"
        />

        <div class="players-type-mob mt-8">
          <ElPopover
            v-model="playerTypeMob"
            placement="bottom"
            trigger="click"
            width="237"
            popper-class="players-type-wrap players-type-wrap__mob"
          >
            <template v-slot:reference>
              <UiButton
                class="btn"
                icon="gear"
                :class="{'btn-sm-active': playerTypeMob || reports[currentReport].playersType === 'new' || reports[currentReport].playersType === 'old'}"
              />
            </template>
            <div>
              <h6>{{ $t('filters.players') }}</h6>
              <div class="btn-group btn-group-sm">
                <button
                  class="btn btn-sm btn-outline-primary"
                  :class="{'btn-sm-active': reports[currentReport].playersType === 'all'}"
                  @click="changePlayersType('all')"
                >
                  {{ $t('customReports.all') }}
                </button>
                <button
                  class="btn btn-sm btn-outline-primary"
                  :class="{'btn-sm-active': reports[currentReport].playersType === 'new'}"
                  @click="changePlayersType('new')"
                >
                  {{ $t('customReports.new') }}
                </button>
                <button
                  class="btn btn-sm btn-outline-primary"
                  :class="{'btn-sm-active': reports[currentReport].playersType === 'old'}"
                  @click="changePlayersType('old')"
                >
                  {{ $t('customReports.old') }}
                </button>
              </div>
            </div>
          </ElPopover>
        </div>
      </div>
      <!-- <div class="toolbar grouping ml-16 mr-16">
        <div class="wrapper">
          <div class="section !tw-flex">
            <div
              v-for="(dimension, dimensionIndex) in groupedDimensions"
              :key="dimension.name"
            >
              <el-dropdown
                v-if="groupingSelectDropdownStatsIndex[dimensionIndex].isShow"
                :show-timeout="0"
                class="select"
                placement="bottom"
                @command="handleGroupingSelect"
              >
                <div :class="{active : groupingSelects[dimension.name]}" class="select-link">
                  <span
                    class="text"
                    @click.prevent="groupingClickBlocked(dimension.name, dimension.items.map(e => e.column_name)) ?
                      selectDefaultGrouping(dimension.items[0].name, $event) : null"
                  >
                    {{ groupingSelectDropdownStatsIndex[dimensionIndex].name }}
                  </span>
                  <i class="fas fa-chevron-down icon--right"/>
                </div>
                <template v-slot:dropdown>
                  <el-dropdown-menu class="ddgroup">
                    <el-dropdown-item
                      v-for="field in groupingSelectDropdownStatsIndex[dimensionIndex].grouping"
                      :key="field.name"
                      :command="field"
                      :class="{selected : groupingSelects[dimension.name] && groupingSelects[dimension.name].name === field.name}"
                      class="grouping_select_item"
                    >
                      {{ (allDimension.find(e => e.column_name === field.name) || []).title }}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div> -->
      <CustomReportsGroupingSelectToolbar
        :grouped-dimensions="groupedDimensions"
        :grouping-select-dropdown-stats-index="groupingSelectDropdownStatsIndex"
        :grouping-selects="groupingSelects"
        @grouping-select="handleGroupingSelect"
        @group-click="handleGroupClick"
      />
      <div class="toolbar tools ml-16 mr-16">
        <div class="wrapper">
          <div class="section section-left">
            <div class="period-wr !tw-flex !tw-flex-col">
              <PeriodWrapper
                :settings="passedPeriod"
                class="sub-affiliates__period mr-8"
                @update="setPeriod"
                @change="setRange"
              />
            </div>
            <UiInput
              v-model.trim="reports[currentReport].searchQuery"
              :class="[
                'custom-reports-header__search-input',
                {'custom-reports-header__search-input_hide': !swowInput},
              ]"
              :placeholder="$t('customReports.search')"
              is-search
              @search="getReport"
            />
          </div>
          <div class="section section-right">
            <div class="!tw-flex">
              <div class="ui-btn-group">
                <UiButton
                  :disabled="disabledActions.exclude"
                  class="btn btn-hide btn-lowercase ui-button-custom-dropdown"
                  @click="beforeCreateReport(null, '!=')"
                >
                  <i class="fas fa-page-break" />
                  {{ $t('customReports.exclude') }}
                </UiButton>
                <ElDropdown
                  trigger="click"
                  class="dropdown-report-icon"
                  placement="bottom-end"
                  @command="handleSelectDrilldown"
                >
                  <UiButton
                    :disabled="disabledActions.exclude || currentReport === 0"
                    class="btn btn-hide btn-lowercase ui-button-custom-dropdown"
                  >
                    <i class="fas fa-chevron-down" />
                  </UiButton>
                  <template v-slot:dropdown>
                    <ElDropdownMenu class="ddgroup-btn">
                      <ElDropdownItem
                        command="continue-exclude"
                        class="grouping_select_item"
                      >
                        {{ $t('customReports.continueNewTab') }}
                      </ElDropdownItem>
                      <ElDropdownItem
                        command="start-exclude"
                        class="grouping_select_item"
                        :class="{'disabled': reports[currentReport].defaultFilter['affiliate_id']}"
                      >
                        {{ $t('customReports.startNewTab') }}
                      </ElDropdownItem>
                    </ElDropdownMenu>
                  </template>
                </ElDropdown>
              </div>

              <div class="ui-btn-group">
                <UiButton
                  :disabled="disabledActions.drilldown"
                  class="btn btn-hide btn-lowercase"
                  icon="shuffle"
                  @click="beforeCreateReport(null, '=')"
                >
                  {{ $t('customReports.drilldown') }}
                </UiButton>
                <ElDropdown
                  trigger="click"
                  class="dropdown-report-icon"
                  placement="bottom-end"
                  @command="handleSelectDrilldown"
                >
                  <UiButton
                    :disabled="disabledActions.drilldown || currentReport === 0"
                    class="btn btn-hide btn-lowercase"
                  >
                    <i class="fas fa-chevron-down" />
                  </UiButton>
                  <template v-slot:dropdown>
                    <ElDropdownMenu class="ddgroup-btn">
                      <ElDropdownItem
                        command="continue-drilldown"
                        class="grouping_select_item"
                      >
                        {{ $t('customReports.continueNewTab') }}
                      </ElDropdownItem>
                      <ElDropdownItem
                        command="start-drilldown"
                        class="grouping_select_item"
                        :class="{'disabled': reports[currentReport].defaultFilter['affiliate_id']}"
                      >
                        {{ $t('customReports.startNewTab') }}
                      </ElDropdownItem>
                    </ElDropdownMenu>
                  </template>
                </ElDropdown>
              </div>

              <div class="select btn-search-icon mb-8">
                <UiButton
                  :class="{'search-fill-btn': swowInput}"
                  class="btn mb-0"
                  icon="search"
                  @click="swowInput = !swowInput"
                />
              </div>
              <div class="players-type-desc">
                <ElPopover
                  ref="playerstype"
                  v-model:visible="playerType"
                  placement="bottom"
                  trigger="click"
                  width="237"
                  popper-class="players-type-wrap"
                >
                  <template v-slot:reference>
                    <UiButton
                      class="btn"
                      icon="gear"
                      :class="{'btn-sm-active': playerType || reports[currentReport].playersType === 'new' || reports[currentReport].playersType === 'old'}"
                      @click="$refs.playerstype.showPopper = !$refs.playerstype.showPopper, openPlayersType($event)"
                    />
                  </template>
                  <div>
                    <h6>{{ $t('filters.players') }}</h6>
                    <div class="btn-group btn-group-sm">
                      <button
                        class="btn btn-sm btn-outline-primary"
                        :class="{'btn-sm-active': reports[currentReport].playersType === 'all'}"
                        @click="changePlayersType('all')"
                      >
                        {{ $t('customReports.all') }}
                      </button>
                      <button
                        class="btn btn-sm btn-outline-primary"
                        :class="{'btn-sm-active': reports[currentReport].playersType === 'new'}"
                        @click="changePlayersType('new')"
                      >
                        {{ $t('customReports.new') }}
                      </button>
                      <button
                        class="btn btn-sm btn-outline-primary"
                        :class="{'btn-sm-active': reports[currentReport].playersType === 'old'}"
                        @click="changePlayersType('old')"
                      >
                        {{ $t('customReports.old') }}
                      </button>
                    </div>
                  </div>
                </ElPopover>
              </div>
              <ExportReport class="tw-mr-8" :export-links="exportUrls" />

              <div class="select">
                <UiButton
                  class="btn btn-eye"
                  icon="eye"
                  :icon-size="12"
                  @click="openColumnsPopup"
                />
              </div>
              <UiButton
                icon="refresh"
                class="export-btn btn btn-lowercase"
                @click="getReport"
              />
            </div>
            <UiPagination
              :key="reports[currentReport].page"
              class="custom-reports-header__pagination"
              :page="reports[currentReport].page"
              :page-size="reports[currentReport].limit || 0"
              :count="count"
              show-size-select
              @page-change="pageChange"
            />
          </div>
        </div>
        <div class="report__sort-wrap">
          <div class="report-wrap pr-8">
            <UiSelectTabs
              v-if="isMobile && !!groupedDimensionsMob.length"
              v-model="reports[currentReport].group_by"
              :list="groupedDimensionsMob"
              @change="changeReport"
            />
          </div>
          <SortBy
            :key="render"
            :columns="getTableFields"
            :sort-by="reports[currentReport].sort_by || reports[currentReport].group_by || 'date_formatted'"
            :sort-dir="reports[currentReport].sort_dir"
            @sort-by="sortBy"
          />
        </div>
      </div>
    </div>

    <div
      v-if="bottomFiltersCondition"
      class="toolbar filters filters-bottom"
      :class="{wavebg: loading}"
    >
      <div
        id="myel"
        class="wrapper"
      >
        <div class="item all">
          <span
            class="field"
            @click="clearCurrentFilter"
          >{{ $t('filters.all') }}</span>
        </div>
        <!-- mobile -->
        <div
          v-if="currentReportFilter"
          class="item"
        >
          <span>
            <span class="field">
              <i
                v-if="firstDefaultFilter && firstDefaultFilter.op == '!='"
                class="fas fa-page-break"
                style="font-size: 11px;"
              />
              <i
                v-else
                class="far fa-random"
                style="font-size: 11px;"
              />
              {{ (allDimension.find(e => e.column_name === Object.keys(reports[currentReport].defaultFilter)[0]) || {}).title }}:
            </span>
            <span class="value">
              <span class="value-text">
                {{ reports[currentReport].defaultFilterName || firstDefaultFilter || '' }}
              </span>
              <ElDropdown
                trigger="click"
                placement="bottom-end"
              >
                <span>
                  {{ firstDefaultFilter
                    ? firstDefaultFilter.selectIdsLength : '' }}
                </span>
                <template v-slot:dropdown>
                  <ElDropdownMenu class="dropdown-reports">
                    <ElDropdownItem
                      v-for="(row, i) in firstDefaultFilter
                        ? firstDefaultFilter.selectedRowList : []"
                      :key="i"
                      class="!tw-flex !tw-justify-between dropdown-item-drill"
                    >
                      <div>
                        {{ row.rowTooltip }}
                      </div>
                      <span
                        class="cross-close"
                        @click="removeCurrentReport(firstDefaultFilter, row)"
                      >×</span>
                    </ElDropdownItem>
                  </ElDropdownMenu>
                </template>
              </ElDropdown>
            </span>
          </span>
          <span
            class="cross-close pt-0"
            @click="removePromocodeReport"
          >×</span>
        </div>

        <div
          v-for="(value, key) in currentReportFilter"
          :key="key"
          class="item"
        >
          <span>
            <span class="field">
              <i
                v-if="currentReportFilter[key].op == '!='"
                class="fas fa-page-break"
                style="font-size: 11px;"
              />
              <i
                v-else
                class="far fa-random"
                style="font-size: 11px;"
              />
              {{ key === 'media_buying_channel_id' || key === 'media_buying_campaign_id' ? $t('customReports.mb') : '' }}
              {{ (allDimension.find(e => e.column_name === key) || {}).title }}:
            </span>
            <span class="value">
              <span class="value-text">
                {{ value.visible || reports[currentReport].currentFilterNames[key] }}
              </span>
              <ElDropdown
                trigger="click"
                placement="bottom-end"
              >
                <span>{{ value.selectIdsLength }}</span>
                <template v-slot:dropdown>
                  <ElDropdownMenu>
                    <ElDropdownItem
                      v-for="(row, i) in value.selectedRowList"
                      :key="i"
                      class="!tw-flex !tw-justify-between dropdown-item-drill"
                    >
                      <div>
                        {{ row.rowTooltip }}
                      </div>
                      <span
                        class="cross-close"
                        @click="removeCurrentDrilldown(value, row)"
                      >×</span>
                    </ElDropdownItem>
                  </ElDropdownMenu>
                </template>
              </ElDropdown>
            </span>
          </span>
          <span
            class="cross-close pt-0"
            @click="removeCurrentFilter(key)"
          >×</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SortBy from '@/components/SortBy.vue';
import PeriodWrapper from '@/views/Dashboard/Reports/Filters/PeriodWrapper.vue';
import CustomReportsCommonMixin from '@/views/Dashboard/CustomReports/custom-reports-common-mixin';
import DimensionsMixin from '@/components/Report/Components/DimensionsMixin';
import ResponsiveMixin from '@/components/Helpers/responsive-mixin';
import BookmarksModal from '@/views/Dashboard/CustomReports/Bookmarks/BookmarksModal.vue';
import BookmarksList from '@/views/Dashboard/CustomReports/Bookmarks/BookmarksList.vue';
import BookmarksListMobile from '@/views/Dashboard/CustomReports/Bookmarks/BookmarksListMobile.vue';
import CustomReportsTabs from '@/views/Dashboard/CustomReports/CustomReportsTabs.vue';
import ExportReport from '@/views/Dashboard/Reports/ExportReport.vue';
import formatCurrency from '@/mixins/format-currency';
import DateMixin from '@/views/Dashboard/Reports/dateMixin';
import CustomReportsGroupingSelectToolbar from '@/views/Dashboard/CustomReports/CustomReportsGroupingSelectToolbar.vue';

export default {
  name: 'CustomReportsHeader',
  components: {
    SortBy,
    PeriodWrapper,
    BookmarksModal,
    BookmarksList,
    BookmarksListMobile,
    CustomReportsTabs,
    ExportReport,
    CustomReportsGroupingSelectToolbar,
  },
  mixins: [
    CustomReportsCommonMixin,
    DimensionsMixin,
    ResponsiveMixin,
    formatCurrency,
    DateMixin,
  ],
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    currency: {
      type: String,
      default: '',
    },
    currentReportProp: {
      type: Number,
      default: null,
    },
    pageSize: {
      type: Number,
      default: 0,
    },
    selectedRow: {
      type: Object,
      default: () => ({}),
    },
    allDimension: {
      type: Array,
      default: () => ([]),
    },
    count: {
      type: Number,
      default: 0,
    },
    exportUrls: {
      type: Object,
      default: () => ({}),
    },
    reports: {
      type: Array,
      default: () => ([]),
    },
    columnsGroups: {
      type: Array,
      default: () => ([]),
    },
    defaultCols: {
      type: Array,
      default: () => ([]),
    },
    disabledActions: {
      type: Object,
      default: () => ({}),
    },
    cacheData: {
      type: Object,
      default: () => ({}),
    },
    groupByField: {
      type: Object,
      default: () => ({}),
    },
    getTableFields: {
      type: Array,
      default: () => [],
    },
    singleGroupingSelect: {
      type: String,
      default: '',
    },
    groupingSelects: {
      type: Object,
      default: () => ({}),
    },
    supportedMetricsProp: {
      type: Array,
      default: () => [],
    },
  },
  emits: [
    'update:singleGroupingSelect',
    'update:groupingSelects',
    'update:selectedRow',
    'update:reports',
    'cache-query',
    'select-report',
    'update:currentReportProp',
    'before-create-report',
    'create-report',
    'drilldown-report',
    'get-report',
    'before-get-report',
    'reset-filters',
  ],
  data() {
    return {
      tabCountVisible: null,
      activeModalIndex: '',
      activeModal: false,
      isPinnedPopover: [],
      isNavTabDropdownVisible: false,
      bookmarks: [],
      isPopoverVis: false,
      isLoadingBookmark: false,
      promocodeReport: {},
      arrayWidthItemForTooltip: [],
      playerType: false,
      playerTypeMob: false,
      passedPeriod: {},
      period: 30,
      swowInput: false,
      allMetrics: [],
      selectIds: [],
      render: 0,
      renders: 0,
      subAffiliateReport: {},
      pCurrentReport: 0,
      isPopoverEditIndex: null,
      isDragged: false,
    };
  },
  computed: {
    currentReportFilter() {
      return this.reports[this.currentReport].currentFilter;
    },
    bottomFiltersCondition() {
      return !this.$_.isEmpty(this.reports[this.currentReport].defaultFilter)
        || this.promocodeReport.promo_code
        || this.subAffiliateReport.sub_affiliate_email;
    },
    firstDefaultFilter() {
      return this.reports[this.currentReport]
        .defaultFilter[Object.keys(this.reports[this.currentReport].defaultFilter)[0]];
    },
    storeGroupedDimension() {
      return this.$store.state.settings.grouped_dimensions || [];
    },
    groupedDimensionsIndex() {
      const result = {};

      for (const dimension of this.storeGroupedDimension) {
        result[dimension.name] = dimension.items.map((item) => item.name);
      }

      return result;
    },
    groupingSelectDropdownStatsIndex() {
      const result =  this.groupedDimensions.map((dimension) => {
        const stats = {};
        stats.isShow = !this.isHiddenMany((dimension.items || []).map((e) => e.column_name));

        if (!stats.isShow) {
          return stats;
        }

        stats.name = this.dimensionsGroups.find((e) => e.group_name === dimension.name).group_name
          === Object.keys(this.groupingSelects)[0]
            ? this.compTitle
            : this.dimensionsGroups.find((e) => e.group_name === dimension.name).title;

        stats.grouping = dimension.items
          .filter((item) => (item.type === dimension.name && this.deleteGroup.indexOf(item.column_name) < 0 ))
          .map((item) => {
            return {
              ...item,
              _title: (this.allDimension.find((e) => e.column_name === item.name) || {}).title,
            };
          });

        return stats;
      });

      return result;
    },
    deleteGroup() {
      const cf = [];
      this.$_.forIn(this.reports[this.currentReport].currentFilter, (e) => { if (e.op === '=') { cf.push(e.group_by); } });
      const df = [];
      this.$_.forIn(this.reports[this.currentReport].defaultFilter, (e) => { if (e.op === '=') { df.push(e.group_by); } });

      return this.$_.concat([], cf, df);
    },
    groupedDimensionsBase() {
      return this.storeGroupedDimension
        .filter((dimension) => !this.isHiddenMany(this.groupedDimensionsIndex[dimension.name]))
        .map((dimension) => ({
          ...dimension,
          items: dimension.items
            .filter((item) => !this.isHidden(item.name))
            .map((item) => ({
              ...item,
              ...this.allDimension.find((y) => y.column_name === item.name),
            })),
        }));
    },
    groupedDimensions() {
      return this.groupedDimensionsBase.map((e) => ({
        name: e.name,
        items: e.items.map((i) => ({
          ...i,
          type: e.name,
        })),
      }));
    },
    dimensionsGroups() {
      return this.$store.state.settings.dimensions_groups || [];
    },
    groupedDimensionsMob() {
      return this.groupedDimensionsBase.map((e) => ({
        id: e.name,
        title: this.dimensionsGroups.find((y) => y.group_name === e.name).title,
        list: e.items.map((i) =>
          // const dimension = this.allDimension.find(y => y.column_name === i.name);

          ({
            ...i,
            text: i.title,
            name: i.title,
            id: i.name,
          })),
      }));
    },
    // groupedDimensionsMob() {
    //   let groupedDimensionsMob = (this.$store.state.settings.grouped_dimensions || []).map(e => {
    //     return {
    //       title: (this.$store.state.settings.dimensions_groups || []).find(y => y.group_name === e.name).title,
    //       list: e.items.map(i => {
    //         const dimension = this.allDimension.find(y => y.column_name === i.name);

    //         return {
    //           text: dimension
    //             ? dimension.title
    //             : '',
    //           id: i.name,
    //         }
    //       }),
    //     }
    //   })
    //   this.renders++

    //   return groupedDimensionsMob;
    // },
    compTitle() {
      let groupTitle = {};
      (this.groupedDimensions || []).map((e) => {
        this.groupingSelects[e.name]
          ? (groupTitle = e.items.find((i) => i.name === this.groupingSelects[e.name].name) || {})
          : '';
      });
      return groupTitle.title;
    },
    currentReport: {
      get() {
        return this.pCurrentReport;
      },
      set(value) {
        this.pCurrentReport = value;
        this.$emit('update:currentReportProp', value);
      },
    },
    getMetrics() {
      return (this.$store.state.settings.metrics || []).map((el) => this.formatMetric(el, this.currency));
    },
  },
  watch: {
    currentReportProp: {
      immediate: true,
      handler(value) {
        this.pCurrentReport = value;
        this.initPassedPeriod(value);
      },
    },
    supportedMetricsProp: {
      immediate: true,
      handler(value) {
        this.supportedMetrics = value;
      },
    },
  },
  async mounted() {
    // document.addEventListener('click', this.eventStop, true);
    await this.getBookmarks();
  },
  beforeUnmount() {
    // document.removeEventListener('click', this.eventStop, true);
  },
  methods: {
    initPassedPeriod(index) {
      this.passedPeriod = {
        from: this.reports[index].dateRange[0],
        to: this.reports[index].dateRange[1],
        period: this.reports[index].period,
      };
    },
    selectReport(index) {
      this.$emit('select-report', index);
    },
    handleSelectDrilldown(command) {
      const report = this.$_.cloneDeep(this.reports[this.currentReport]);
      switch (command) {
        case 'continue-exclude':
          this.reports.push(report);
          this.currentReport = this.reports.length - 1;
          this.drilldownReport('!=');
          return;
        case 'start-exclude':
          this.createReport(null, '!=');
          return;
        case 'continue-drilldown':
          this.reports.push(report);
          this.currentReport = this.reports.length - 1;
          this.drilldownReport('=');
          return;
        case 'start-drilldown':
          this.createReport(null, '=');
      }
    },
    isHidden(dimesnsion) {
      return Boolean((this.reports[this.currentReport].defaultFilter[dimesnsion] !== void 0 && this.reports[this.currentReport].defaultFilter[dimesnsion].op !== '!=')
        || (this.reports[this.currentReport].currentFilter[dimesnsion] !== void 0 && this.reports[this.currentReport].currentFilter[dimesnsion].op !== '!='));
    },
    isHiddenMany(list) {
      return list
        .map((e) => Boolean(this.isHidden(e)))
        .every((e) => e);
    },
    handleSingleGroupingSelect(nv) {
      // this.$refs.dataTable.$refs.dataTable.setCurrentRow();
      this.$emit('update:selectedRow', {});
      // this.$refs.dataTable.clearCheck();

      this.$emit('update:singleGroupingSelect', '');
      this.$emit('update:groupingSelects', {
        [nv.type]: {
          ...nv,
          name: nv.id,
        },
      });

      const reports = this.$_.cloneDeep(this.reports);

      if (reports[this.currentReport].sort_by === reports[this.currentReport].group_by) {
        reports[this.currentReport].sort_by = nv.id;
      }
      reports[this.currentReport].group_by = nv.id;
      reports[this.currentReport].searchQuery = '';
      reports[this.currentReport].page = 1;

      this.$emit('update:reports', reports);

      this.$nextTick(() => {
        this.getReport('handle single select');
      });
    },
    selectDefaultGrouping(name, event) {
      event.stopPropagation(true);
      const field = this.$_.find(this.allDimension, { name });
      this.handleGroupingSelect(field);
    },
    handleGroupingSelect(gb) {
      // this.$refs.dataTable.$refs.dataTable.setCurrentRow();
      this.$emit('update:selectedRow', {});
      // this.$refs.dataTable.clearCheck();
      this.$emit('update:singleGroupingSelect', '');
      this.$emit('update:groupingSelects', {
        [gb.type]: gb,
      });

      if (this.reports[this.currentReport].sort_by === this.reports[this.currentReport].group_by) {
        this.reports[this.currentReport].sort_by = gb.name;
      }

      this.reports[this.currentReport].group_by = gb.name;

      const reports = this.$_.cloneDeep(this.reports);
      reports[this.currentReport].searchQuery = '';
      reports[this.currentReport].page = 1;
      this.$emit('update:reports', reports);

      this.getReport('handle grouping select');
    },
    getExportLink(format) {
      return (this.exportUrls || {})[format];
    },
    changeReport(report) {
      this.$emit('update:singleGroupingSelect', report.id);
      this.handleSingleGroupingSelect(report);
    },
    setPeriod(period) {
      if (this.$_.isEqual(this.period, period)) {
        this.reports[this.currentReport].page = 1;
      }

      let fixed = null;
      if (period?.period) {
        fixed = this.fixRange(period);
        if (fixed) {
          period.from = fixed.from;
          period.to = fixed.to;
        }
      }

      const periodItems = [7, -70, -7, -14, 30, -30, 100, 365, -365, -3650];

      this.reports[this.currentReport].dateRange[0] = period.from;
      this.reports[this.currentReport].dateRange[1] = period.to;
      this.reports[this.currentReport].period = period.period;
      this.period = period;

      if (period.period === 1) {
        this.passedPeriod = { range: [period.from, period.to] };
      } else if (periodItems.includes(period.period)) {
        this.passedPeriod = { period: period.period };
      } else {
        this.passedPeriod = {
          period: `${moment(period.from)
            .format('YYYY-MM-DD')} ${this.$t('periodWrapper.to')} ${moment(period.to)
            .format('YYYY-MM-DD')}`,
        };
      }

      this.period.period = this.passedPeriod.period;
      // this.loading = true;
    },
    clearCurrentFilter() {
      // this.$refs.dataTable.$refs.dataTable.setCurrentRow();
      // this.selectedRow = {};
      this.$emit('update:selectedRow', {});
      this.reports[this.currentReport].currentFilter = {};
      this.reports[this.currentReport].page = 1;
      this.getReport('clear filter');
    },
    removeCurrentFilter(filter) {
      // this.$refs.dataTable.$refs.dataTable.setCurrentRow();
      // this.selectedRow = {};
      this.$emit('update:selectedRow', {});
      this.$delete(this.reports[this.currentReport].currentFilter, filter);
      this.reports[this.currentReport].page = 1;
      this.reports[this.currentReport].group_by = this.reports[this.currentReport].prevDimension;
      this.reports[this.currentReport].sort_by = this.reports[this.currentReport].prevDimension;
      // this.singleGroupingSelect = this.reports[this.currentReport].prevDimension;
      this.$emit('update:singleGroupingSelect', this.reports[this.currentReport].prevDimension);
      const dimmension = this.allDimension.find((e) => e.name === this.reports[this.currentReport].prevDimension);
      const prev = this.allDimension[this.allDimension.indexOf(dimmension) - 1] || this.allDimension[0];
      this.reports[this.currentReport].prevDimension = prev.name;
      // this.groupingSelects = {};
      // this.groupingSelects[this.groupByField.type] = this.groupByField;
      this.$emit('update:groupingSelects', {
        [this.groupByField.type]: this.groupByField,
      });
      this.getReport('remove filter');
    },
    removeCurrentReport(value, row) {
      const filterList = this.updateFilter(this.reports[this.currentReport].defaultFilter[value.group_by], row);

      this.reports[this.currentReport].defaultFilter[value.group_by] = filterList;
      this.reports[this.currentReport].defaultFilterName = filterList.selectedRowList[0].rowTooltip;
      this.getReport('removeCurrentReport');
    },
    removeCurrentDrilldown(value, row) {
      const filterList = this.updateFilter(this.reports[this.currentReport].currentFilter[value.group_by], row);

      this.reports[this.currentReport].currentFilter[value.group_by] = filterList;
      this.getReport('removeCurrentDrilldown');
    },
    updateFilter(filterList, row) {
      filterList.row_id = filterList.row_id.filter((e) => e !== row.row_id);
      filterList.selectedRow = filterList.selectedRow.filter((e) => e !== row.rowTooltip);
      filterList.selectedRowList = filterList.selectedRowList.filter((e) => e.row_id !== row.row_id);
      return {
        row_id: filterList.row_id,
        visible: filterList.selectedRowList[0].rowTooltip,
        group_by: filterList.group_by || '',
        op: filterList.op,
        selectIdsLength: filterList.row_id.length <= 1 ? '' : `[+${filterList.row_id.length - 1}]`,
        selectedRow: filterList.selectedRow,
        selectedRowList: filterList.selectedRowList,
        row_filter_column: filterList.row_filter_column,
      };
    },
    removePromocodeReport() {
      this.isPopoverEditIndex = null;
      this.removePromocode();
      this.selectReport(0);
      this.reports.splice(1);
    },
    removePromocode() {
      this.promocodeReport = {};
      this.subAffiliateReport = {};
    },
    beforeCreateReport(customSettings, op) {
      this.$emit('before-create-report', customSettings, op);
    },
    createReport(customSettings, op, changeOp) {
      this.$emit('create-report', customSettings, op, changeOp);
    },
    drilldownReport(op) {
      this.$emit('drilldown-report', op);
    },
    setRange(period) {
      this.setPeriod(period);
      this.getReport('setRange');
    },
    getReport() {
      this.$emit('get-report', this.reports[this.currentReport]);
    },
    beforeGetReport(value) {
      this.$emit('before-get-report', value);
    },
    openColumnsPopup() {
      this.$refs.columnsPopup.open(this.reports[this.currentReport].selectedColumns);
    },
    sortBy(sort) {
      this.reports[this.currentReport].sort_dir = sort.sort_dir;
      this.reports[this.currentReport].sort_by = sort.sort_by;
      this.getReport('sortBy');
    },
    pageChange(page, size) {
      if (this.reports[this.currentReport].page !== page || this.reports[this.currentReport].limit !== size) {
        // this.$refs.dataTable.$refs.dataTable.setCurrentRow();
        this.reports[this.currentReport].page = page;
        this.reports[this.currentReport].limit = size;
        this.getReport('handle page change');
      }
    },
    openPlayersType(event) {
      // vue3-migration -- структура рефов поменялась
      // const popper = this.$refs.playerstype.$refs.popper;
      // let listener3;
      // document.addEventListener('mousedown', listener3 = (e) => {
      //   if (event.target !== e.target && (e.clientY > popper.offsetTop + popper.offsetHeight || e.clientY < popper.offsetTop || e.clientX > popper.offsetLeft + popper.offsetWidth || e.clientX < popper.offsetLeft)) {
      //     this.$refs.playerstype.showPopper = false;
      //     document.removeEventListener('mousedown', listener3);
      //   }
      // });
    },
    lastTab() {
      this.$refs.tabs.lastTab();
    },
    getBookmarks() {
      this.isLoadingBookmark = true;
      return this.$api.getBookmarks()
        .then((response) => {
          this.bookmarks = response.payload;
          this.isLoadingBookmark = false;
          if (this.bookmarks.length === 0) {
            this.isPopoverVis = false;
          }
        })
        .catch((error) => {
          console.log(error);
          this.isLoadingBookmark = false;
        });
    },
    groupingClickBlocked(type, groups) {
      if (
        (this.groupingSelects[type] && this.groupingSelects[type].type === type)
          || !groups.every((e) => !this.isHidden(e))
      ) {
        return false;
      }
      return true;
    },
    openBookmarksModal(index, event) {
      if (this.$refs.bookmarksModal) {
        this.$refs.bookmarksModal.open(index, event);
      }
    },
    resetFilters(index) {
      this.$emit('reset-filters', index);
      this.passedPeriod = this.reports[index].period;
    },
    changePlayersType(type) {
      this.playerType = false;
      this.playerTypeMob = false;
      this.reports[this.currentReport].playersType = type;
      this.getReport('changePlayersType');
    },
    handleGroupClick(event, dimension) {
      if (this.groupingClickBlocked(dimension.name, dimension.items.map((e) => e.column_name))) {
        this.selectDefaultGrouping(dimension.items[0].name, event);
      }
    },
  },
};
</script>

<style lang="scss">
.custom-reports-header {
  .ui-button-custom-dropdown{
    &.disabled {
      &:active,
      &:focus {
        background-color: #fff;
      }
    }
  }
  &__search-input {
    @media (max-width: 650px) {
      & {
        display: flex;
        width: calc(100% + 126px) !important;
        margin: 0 0 10px !important;
      }

      &_hide {
        display: none;
      }
    }
  }
}
</style>
